import { render } from "./EditBlog.vue?vue&type=template&id=37822d89"
import script from "./EditBlog.vue?vue&type=script&lang=js"
export * from "./EditBlog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__